import { render, staticRenderFns } from "./ProfileImagePrompt.vue?vue&type=template&id=cff78dd6&scoped=true"
import script from "./ProfileImagePrompt.vue?vue&type=script&lang=js"
export * from "./ProfileImagePrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff78dd6",
  null
  
)

export default component.exports